import React from 'react';

import { useField } from 'formik';

import { useFetchAllSuggestions } from '../../../../../Suggestions';
import MutateRuleValues from '../../../MutateTaskRules/MutateRule/MutateRuleValues';

import './index.scss';

const MutateCardTags = ({ name, language }) => {
  const [field] = useField(name);
  const { suggestions, suggestionsAsOptions } =
    useFetchAllSuggestions(language);
  return (
    <div className="mutate-card-tags">
      <h5>Tags</h5>
      <MutateRuleValues
        ruleField=""
        translations={suggestions}
        options={suggestionsAsOptions}
        name={name}
        value={field.value}
        theme=""
        language={language}
      />
    </div>
  );
};

export default MutateCardTags;
